import axios from 'axios';
import {backendHost} from '../../config';

export const putOffer = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/offer`, params);
};